module.exports = __webpack_public_path__ + "static/Styled-Components-6d94f33ca2440979e0ba969184403335.png";